import React, { FC } from 'react'
import { t } from '@lingui/macro'

import GenericAccessModal, {
  AccessModalMode
} from '../../manage-pathways-page/components/GenericAccessModal'
import { IMembersSelectorMembers } from '../../../components/common/members-selector/MembersSelector'
import {
  useAddUserToWorkspaceMutation,
  useAddGroupToWorkspaceMutation
} from './AddMembersModal.codegen'

interface IProps {
  workspaceId: number
  show: boolean
  onCancel?: () => void
  onSubmitted?: () => void
  membersSelected?: IMembersSelectorMembers
}

export const AddMembersModal: FC<IProps> = ({
  show,
  workspaceId,
  onCancel,
  onSubmitted
}) => {
  const [addUserToWorkspace] = useAddUserToWorkspaceMutation()
  const [addGroupToWorkspace] = useAddGroupToWorkspaceMutation()

  return (
    <GenericAccessModal
      show={show}
      mode={AccessModalMode.ONLY_ACCESS}
      onCancel={onCancel}
      onSubmitted={onSubmitted}
      header={t`Invite to this workspace`}
      addUser={async (userId) => {
        await addUserToWorkspace({
          variables: {
            workspaceId,
            userId: userId
          }
        })
      }}
      addGroup={async (groupId) => {
        await addGroupToWorkspace({
          variables: {
            workspaceId,
            groupId
          }
        })
      }}
    />
  )
}
